import { Skeleton, Stack } from "@mui/material";

interface PlacementsLoaderProps {
  count?: number;
}

export function PlacementsLoader(props: PlacementsLoaderProps) {
  const { count = 3 } = props;

  return (
    <Stack direction="column" spacing={2}>
      {Array.from({ length: count }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Skeleton key={index} variant="rounded" width="100%" height={205} />
      ))}
    </Stack>
  );
}
